import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // Import useLocation and useNavigate
import "./OTPVerification.css"; // Assuming you have styles for OTP verification
import axiosInstance from "../axiosinstance";

const OtpVerification = () => {
  const location = useLocation(); // Get location object
  const navigate = useNavigate(); // Initialize useNavigate for navigation
  // const email = location.state?.email || ""; // Retrieve the email passed from ForgotPassword via state
  const [email, setEmail] = useState(
    () => location.state?.email || sessionStorage.getItem("otp_email") || ""
  );

  useEffect(() => {
    if (location.state?.email) {
      sessionStorage.setItem("otp_email", location.state.email);
      setEmail(location.state.email);
    } else if (!email) {
      // no email in state or storage — user likely refreshed or opened page directly
      navigate("/forgot-password", { replace: true });
    }
  }, [location.state, email, navigate]);

  const [otp, setOtp] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const getBackendMessage = (payloadOrError) => {
    const data = payloadOrError?.response?.data || payloadOrError;
    if (!data) return "";
    if (typeof data === "string") return data;
    return data.message || data.error || "";
  };

  const handleOTPVerification = async (e) => {
    e.preventDefault();
    setAlertMessage(""); // Clear any previous alert message

    if (!otp.trim()) {
      setAlertMessage("Please enter the OTP.");
      return;
    }

    try {
      setLoading(true);

      // Prepare the payload
      const payload = {
        otp: otp,
        email: email, // Include email and OTP in the request body
      };

      // Send the payload in the request body directly
      const response = await axiosInstance.post("/api/verify_otp", payload);
      const responseData = response?.data || {};
      const resetToken = responseData?.reset_token;
      const hasToken =
        typeof resetToken === "string" && resetToken.trim().length > 0;
      const verified = responseData?.success === true && hasToken;

      if (verified) {
        sessionStorage.setItem("otp_email", email);
        sessionStorage.setItem("reset_email", email);
        sessionStorage.setItem("reset_token", resetToken);

        navigate("/confirm-password", {
          state: { email, resetToken },
          replace: true,
        });
      } else {
        sessionStorage.removeItem("reset_token");
        setAlertMessage(
          getBackendMessage(responseData) ||
            "OTP verification failed. Please try again."
        );
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      const backendMessage = getBackendMessage(error);
      if (backendMessage) {
        setAlertMessage(getBackendMessage(error));
      } else {
        setAlertMessage("A server error occurred. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="otp-verification-container">
      <h2 className="otp-verification-title">OTP Verification</h2>
      {alertMessage && <div className="alert-message">{alertMessage}</div>}

      <form onSubmit={handleOTPVerification} className="otp-form">
        <label htmlFor="otp" className="otp-label">
          Enter OTP:
        </label>
        <input
          type="text"
          id="otp"
          className="otp-input"
          placeholder="Enter the OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />

        <button type="submit" disabled={loading} className="otp-submit-button">
          {loading ? "Verifying..." : "Verify OTP"}
        </button>
      </form>
    </div>
  );
};

export default OtpVerification;
